import React, { useState } from "react";
import { motion } from "framer-motion";
import { useParams } from "react-router-dom";
import "./PackageBooking.css";
import api from "../../Api.js"
import SuccessModal from "../ExtraComponent/SuccessModal.jsx";
import Common_navber from "../Home/Common_navber.jsx";

const BookingPage = () => {
    const { id } = useParams(); // This is the package_id from URL
    const [showModal, setShowModal] = useState(false);

    const [formData, setFormData] = useState({
        date: "",
        name: "",
        email: "",
        phone: "",
        guests: "",
        requests: "",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // ✅ Format data according to backend
        const payload = {
            package_id: id,
            event_date: formData.date,
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            guests: parseInt(formData.guests),
            special_request: formData.requests,
        };

        console.log("Sending Booking Data:", payload);
        const response = await api.post("banquet/package-booking", payload)
        console.log("the response after booking creation by user ", response.data)
        if (response.data.status === true) {
            // alert("Your Booking has been created Successfully!");
            setFormData({
                date: "",
                name: "",
                email: "",
                phone: "",
                guests: "",
                requests: "",
            })

        }
        setShowModal(true)

    };

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    const minDate = tomorrow.toISOString().split("T")[0];


    return (
        <div>
            <Common_navber />
            <motion.div
                className="pb-container"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
            >
                <SuccessModal show={showModal} onClose={() => setShowModal(false)} message="Your Booking has been successfully Created" />
                <h1 className="pb-title">Book Your Dream Package</h1>
                <p className="pb-subtitle">
                    One-click booking for an unforgettable celebration.
                </p>

                <form onSubmit={handleSubmit} className="pb-form">

                    <label className="pb-label">Your Name</label>
                    <input
                        type="text"
                        name="name"
                        placeholder="Enter full name"
                        value={formData.name}
                        onChange={handleChange}
                        className="pb-input"
                        required
                    />

                    <label className="pb-label">Email Address</label>
                    <input
                        type="email"
                        name="email"
                        placeholder="Enter email"
                        value={formData.email}
                        onChange={handleChange}
                        className="pb-input"
                        required
                    />

                    <label className="pb-label">Phone Number</label>
                    <input
                        type="tel"
                        name="phone"
                        placeholder="Enter phone number"
                        value={formData.phone}
                        onChange={handleChange}
                        className="pb-input"
                        required
                    />

                    <label className="pb-label">Event Date</label>
                    <input
                        type="date"
                        name="date"
                        min={minDate}
                        value={formData.date}
                        onChange={handleChange}
                        className="pb-input"
                        required
                    />


                    <label className="pb-label">Number of Guests</label>
                    <input
                        type="number"
                        name="guests"
                        placeholder="Enter guest count"
                        value={formData.guests}
                        onChange={handleChange}
                        className="pb-input"
                        required
                    />

                    <label className="pb-label">Special Requests</label>
                    <textarea
                        name="requests"
                        placeholder="Any specific requirements or preferences?"
                        value={formData.requests}
                        onChange={handleChange}
                        className="pb-textarea"
                    />

                    <motion.button
                        whileHover={{ scale: 1.04 }}
                        whileTap={{ scale: 0.96 }}
                        type="submit"
                        className="pb-btn"
                    >
                        Submit Booking Request
                    </motion.button>
                </form>
            </motion.div>
        </div>

    );
};

export default BookingPage;
